import { useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { applyPalette } from '../lib/theme';
import { PALETTES, type PaletteKey } from '../theme/palettes';

export default function AmbiancePicker() {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) return null;
  const current = (user.mood ?? 'sauge') as PaletteKey;
  const currentName = PALETTES[current as PaletteKey]?.name ?? 'Sauge';

  async function pick(key: PaletteKey) {
    applyPalette(key);
    try {
      await api.patch('/me', { mood: key });
      await refresh();
    } catch {
      /* UI applique déjà ; rollback si besoin laissé côté user */
    }
  }

  return (
    <div className="ambiance-picker">
      <button
        className="ambiance-current"
        onClick={() => setOpen((v) => !v)}
        title="Changer l'ambiance visuelle"
      >
        <span
          className="ambiance-swatch"
          style={{ background: PALETTES[current]?.sage ?? '#81B29A' }}
        />
        <span className="ambiance-current-text">
          <span className="card-meta" style={{ fontSize: 11 }}>
            Ambiance
          </span>
          <span style={{ fontWeight: 600 }}>{currentName}</span>
        </span>
        <span style={{ color: 'var(--c-muted)' }}>{open ? '▾' : '▸'}</span>
      </button>

      {open && (
        <div className="ambiance-grid">
          {Object.values(PALETTES).map((p) => (
            <button
              key={p.key}
              className={`ambiance-chip ${current === p.key ? 'active' : ''}`}
              onClick={() => pick(p.key)}
              title={p.tagline}
            >
              <div className="ambiance-chip-swatches">
                <span style={{ background: p.sidebar }} />
                <span style={{ background: p.sage }} />
                <span style={{ background: p.terracotta }} />
                <span style={{ background: p.nav }} />
              </div>
              <span className="ambiance-chip-name">{p.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
